import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { InfoBox } from "../../../uikit/InfoBox";
import { SanitizeHTMLString } from "../../../uikit/SanitizeContent";
import { Typography } from "../../../uikit/Typography";
import { useCurrentUserLocationInfo } from "./useCurrentUserLocationInfo";

const i18nRoot = "crm.filters.notices";

export const LocationNotice = () => {
  const {
    platformLocationText,
    shouldShowUpdateYourLocationNotice,
    shouldShowReviewYourLocationNotice,
  } = useCurrentUserLocationInfo();

  return (
    <>
      {shouldShowUpdateYourLocationNotice && (
        <InfoBox className="!bg-v2-warning/20 !border-v2-warning/30 mt-2 flex !w-auto flex-row border">
          <div className="flex flex-row gap-3">
            <div>
              <Icon type="20-info" size={20} />
            </div>
            <div>
              <Typography.LabelMd weight="semibold" color="text-primary">
                {t([i18nRoot, "update_your_location.title"])}
              </Typography.LabelMd>
              <br />
              <Typography.BodySm color="text-secondary">
                {t([i18nRoot, "update_your_location.description"])}
              </Typography.BodySm>
            </div>
          </div>
        </InfoBox>
      )}
      {shouldShowReviewYourLocationNotice && (
        <InfoBox className="bg-tertiary border-tertiary mt-2 flex !w-auto flex-row border">
          <div className="flex flex-row gap-3">
            <div>
              <Icon type="20-checkmark-circle" size={20} />
            </div>
            <div>
              <Typography.BodySm color="text-secondary">
                <SanitizeHTMLString
                  content={t([i18nRoot, "we_updated_your_location"], {
                    location: platformLocationText,
                  })}
                />
              </Typography.BodySm>
            </div>
          </div>
        </InfoBox>
      )}
    </>
  );
};
